export default "__VITE_ASSET__CSJX7pN$__"